import React from 'react';
import {
  Users, DollarSign, FileText, TrendingUp, Calendar, Filter, Download, RefreshCw, CheckCircle, XCircle, Clock, Search, Mail, Phone, Building, CreditCard, Percent, AlertTriangle, Check, X, Edit2, Save, Wallet, Send, ArrowRight, Banknote, Bell, Trash2, Eye
} from 'lucide-react';
import { useSuperAdminContext } from '../SuperAdminContext';

export default function VerificationTab() {
  const ctx = useSuperAdminContext();
  const { activeTab, fetchPendingVerifications, handleBankVerification, pendingVerifications, rejectionReason, selectedUser, setRejectionReason, setSelectedUser, setShowRejectModal, showRejectModal } = ctx;

  return (
    <>
            {activeTab === 'verification' && (
              <div className="verification-content">
                <div className="content-header">
                  <h2>
                    <CreditCard size={24} />
                    Bank Account Verification
                  </h2>
                  <button className="btn-secondary" onClick={fetchPendingVerifications}>
                    <RefreshCw size={16} /> Refresh
                  </button>
                </div>

                {pendingVerifications.length === 0 ? (
                  <div className="empty-state">
                    <CheckCircle size={48} className="icon-success" />
                    <h3>All Caught Up!</h3>
                    <p>No pending bank verifications at this time.</p>
                  </div>
                ) : (
                  <div className="verification-list">
                    {pendingVerifications.map((user) => (
                      <div key={user.id} className="verification-card">
                        <div className="verification-header">
                          <div className="business-info">
                            <h3><Building size={18} /> {user.business_name}</h3>
                            <p className="business-email"><Mail size={14} /> {user.email}</p>
                          </div>
                          <span className="badge badge-pending">
                            <Clock size={14} /> Pending Verification
                          </span>
                        </div>
                        
                        <div className="bank-details-grid">
                          <div className="detail-item">
                            <span className="label">Bank Name</span>
                            <span className="value">{user.bank_name || 'Not provided'}</span>
                          </div>
                          <div className="detail-item">
                            <span className="label">Account Holder</span>
                            <span className="value">{user.bank_account_name || user.owner_name || 'Not provided'}</span>
                          </div>
                          <div className="detail-item">
                            <span className="label">Account Number</span>
                            <span className="value">****{user.bank_account_number?.slice(-4) || '****'}</span>
                          </div>
                          <div className="detail-item">
                            <span className="label">Routing Number</span>
                            <span className="value">****{user.bank_routing_number?.slice(-4) || '****'}</span>
                          </div>
                          <div className="detail-item">
                            <span className="label">Account Type</span>
                            <span className="value">{user.bank_account_type || 'Checking'}</span>
                          </div>
                          <div className="detail-item">
                            <span className="label">Tax ID</span>
                            <span className="value">{user.tax_id ? `****${user.tax_id.slice(-4)}` : 'Not provided'}</span>
                          </div>
                        </div>

                        <div className="verification-actions">
                          <button 
                            className="btn-success"
                            onClick={() => handleBankVerification(user.id, 'approve')}
                          >
                            <Check size={16} /> Approve
                          </button>
                          <button 
                            className="btn-danger"
                            onClick={() => {
                              setSelectedUser(user);
                              setShowRejectModal(true);
                            }}
                          >
                            <X size={16} /> Reject
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Rejection Modal */}
                {showRejectModal && selectedUser && (
                  <div className="modal-overlay" onClick={() => setShowRejectModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                      <h3><AlertTriangle size={20} /> Reject Bank Account</h3>
                      <p>Rejecting bank account for: <strong>{selectedUser.business_name}</strong></p>
                      <div className="form-group">
                        <label>Reason for Rejection *</label>
                        <textarea
                          value={rejectionReason}
                          onChange={(e) => setRejectionReason(e.target.value)}
                          placeholder="Please provide a reason for rejection..."
                          rows={4}
                        />
                      </div>
                      <div className="modal-actions">
                        <button className="btn-secondary" onClick={() => setShowRejectModal(false)}>
                          Cancel
                        </button>
                        <button 
                          className="btn-danger" 
                          onClick={() => handleBankVerification(selectedUser.id, 'reject')}
                          disabled={!rejectionReason.trim()}
                        >
                          Confirm Rejection
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
    </>
  );
}
